@if (bannerUIModel$ | async; as uiModel) {
  @if (uiModel.profit > 0) {
    <div class="banner-container card" [ngClass]="{ 'mod-adp staking-widget': !!uiModel.stakeable }">
      <div class="banner-info-wrapper" [ngClass]="{ 'mod-adp': !!uiModel.stakeable }">
        <svg-inline [src]="'/assets/images/staking/staking_rewards.svg'" [alt]="'logo_alt_text' | translate" />
        <span class="banner-text-title" [ngClass]="{ 'mod-adp': !!uiModel.stakeable }">
          {{
          "staking_banner_text"
          | translate: [uiModel.profit | fiat_precision | percent_symbol: false, stakeableName]
          }}
        </span>
      </div>
      <div class="actions">
        <button
          class="btn btn-primary btn-inverse btn-staking-banner"
          [ngClass]="{ 'btn-inverse': !uiModel.stakeable }"
          (click)="openFlow('stake', uiModel.stakeable)">
          {{ "staking_banner_button" | translate }}
        </button>
      </div>
    </div>
  }
}
